















import Vue from 'vue';
import { NuxtError } from '@nuxt/types';
import { TranslateResult } from 'vue-i18n';
import Meta from '@root/common/utils/Meta';

interface Data {
  mounted: boolean;
}

interface CustomNuxtError extends NuxtError {
  debug?: Record<string, unknown>;
}

interface Props {
  error: CustomNuxtError;
}

interface Computed {
  errorMessage: TranslateResult;
  isFrontpage: boolean;
}

interface Methods {
  getTranslation: (message: string) => TranslateResult;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mounted: false,
    };
  },
  head() {
    const settings = this.$channelConfig('meta').base;
    const meta = new Meta(this.$channelConfig('meta').base, this.$route.path);
    meta.setTitle({ title: `${this.errorMessage} - ${settings.title}` });

    return {
      title: meta.title,
    };
  },
  computed: {
    errorMessage() {
      const msg = this.error?.message || '';
      // Try to handle all edge cases before showing message
      const showCustomMessage = !!msg && typeof msg === 'string' && msg !== '{}';
      return showCustomMessage ? this.getTranslation(msg) : this.$t('error.page_not_found');
    },
    isFrontpage() {
      return this.$route.name === 'frontpage';
    },
  },
  mounted() {
    const { error } = this;

    this.mounted = true;

    console.error(`Error: ${error?.statusCode}`, error);
    this.$sentry.captureException(error, {
      tags: { 'process.server': process.server ? 'server' : 'client' },
      contexts: { vue: { componentName: 'error.vue layout' } },
    });
  },
  methods: {
    getTranslation(message) {
      return this.$te(message) ? this.$t(message) : this.$t('error.page_not_found');
    },
  },
});
